import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

/**
 * The company logotype, set in type.
 *
 * There is no logo asset yet — the file that shipped in `public/` was an
 * unrelated placeholder — so the name is typeset instead of drawn. This is the
 * single place to swap in a real mark: replace the markup below with an `<img>`
 * and both the header and the footer follow.
 */
export function Wordmark({ className }: { className?: string }) {
  const { t } = useTranslation()

  return (
    <span className={cn('flex flex-col leading-none', className)}>
      <span className="font-display text-[0.9375rem] font-bold tracking-[0.14em] uppercase sm:text-base">
        {t('brand.name')}
      </span>
      <span className="text-caption mt-1 tracking-[0.3em] uppercase opacity-70">
        {t('brand.suffix')}
      </span>
    </span>
  )
}
